import React from "react";
import { t } from "ttag";

import { FORM_ERROR_CLASS_NAME } from "../../../forms/classNames";

export const PayLater = (): React.ReactNode => {
    return (
        <div className={FORM_ERROR_CLASS_NAME}>
            <p>
                <strong>
                    {t`Our payment processor is currently experiencing technical issues. You may submit your order now and our team will contact you to confirm payment as soon as our credit card payment system is operational.`}
                </strong>
                <br />
                <br />
                <strong>
                    {t`Our team will call you at the phone number provided in checkout and use your order number to verify your information.`}
                </strong>
                <br />
                <br />
                <strong>
                    {t`Alternatively you may try placing your order again later. We sincerely apologize for any inconvenience.`}
                </strong>
            </p>
        </div>
    );
};
